export default __webpack_public_path__ + "static/media/yearly.98cc4a79.gif";